const CONTROL_OR_BACKSLASH = /[\u0000-\u001f\u007f\\]/
const MAX_DECODE_PASSES = 5

export function safeRelativePath(value: string | undefined, fallback: string) {
  if (!value?.startsWith('/') || value.startsWith('//')) return fallback

  let decoded = value
  for (let index = 0; index < MAX_DECODE_PASSES; index += 1) {
    if (CONTROL_OR_BACKSLASH.test(decoded) || decoded.startsWith('//')) {
      return fallback
    }

    try {
      const next = decodeURIComponent(decoded)
      if (next === decoded) break
      decoded = next
    } catch {
      return fallback
    }
  }

  if (CONTROL_OR_BACKSLASH.test(decoded) || decoded.startsWith('//')) {
    return fallback
  }

  const base = new URL('https://nextclinic.invalid')
  const parsed = new URL(value, base)
  return parsed.origin === base.origin ? value : fallback
}

export function currentRelativePath(
  location: Pick<Location, 'hash' | 'pathname' | 'search'>,
) {
  return `${location.pathname}${location.search}${location.hash}`
}
